export class AppConstants {
    //#region Route
    static ROUTES = class {
        public static readonly HOME = 'home';

        //#region MAIN
        public static readonly MAIN = "main";
        public static readonly SERVICE_INTRODUCTION = "service-introduction";
        //#endregion



        //#region Authentication
        public static readonly AUTHENTICATION = "authentication";
        public static readonly LOGIN = "login";
        public static readonly OTP_Page = "otp";
        public static readonly REGISTER = "register";
        public static readonly MY_ACCOUNT = "my-account";
        public static readonly MY_PROFILE ="my-profile";
        public static readonly FORGET_EMAIL ="forget-email";
        public static readonly CHANGE_PASS = "changePassword";
        public static readonly SUCCESS = "success";
        public static readonly Profile = "profile";
        public static readonly Messages = "Messages";
        public static readonly verifyEmail = "verify-email";
        public static readonly MICROSOFT_CALLBACK = "microsoft-callback";
        //#endregion
        public static readonly VendorApplication = "VendorApplication";
        public static readonly BankAccount = "BankAccount";
        public static readonly email = "email";

        //#region home


        //#endregion

        // Region Tender
        public static readonly TENDER = "tender";
        public static readonly TENDERDETAILS = "tenderdetails";
        public static readonly CREATE_TENDER = "create";
        // endregion

        // Region Practice
        public static readonly PRACTICE = "practice";
        public static readonly FWA_PRACTICE = "fwa-practice";
        public static readonly PRACTICEDETAILS = "practicedetails";
        public static readonly CREATE_PRACTICE = "create";
        // endregion

        //#region Approved PRs
        public static readonly APPROVED_PRS = "approved-prs";
        public static readonly PRDETAILS = "prdetails";
        //#endregion


        //#region bid
        public static readonly BID = "bid";
        public static readonly BIDDETAILS = "biddetails";
        //#endregion

        //#region Evaluations
        public static readonly EVALUATIONS = "evaluations";
        public static readonly ASSIGN_EVALUATORS = "assign-evaluators";
        public static readonly EVALUATION_SCORING = "evaluation-scoring";
        public static readonly EVALUATION_DETAILS = "evaluation-details";
        //#endregion

        //#region Meetings
        public static readonly MEETINGS = "meetings";
        public static readonly CREATE_MEETING = "create";
        public static readonly VIEW_MEETING = "view";
        //#endregion

        //#region Minutes of Meeting
        public static readonly MINUTES_OF_MEETING = "minutes-of-meeting";
        public static readonly MINUTES_OF_MEETING_DETAILS = "minutes-of-meeting-details";
        //#endregion

        //#region Agenda Items
        public static readonly AGENDA_ITEMS = "agenda-items";
        //#endregion

        //#region FAQs
        public static readonly FAQS = "faqs";
        public static readonly VIEW_FAQ = "view";
        //#endregion

        //#region Vendors
        public static readonly VENDORS = "manage-vendors";
        public static readonly VENDOR_DETAILS = "details";
        //#endregion

        //#region Lookups
        public static readonly LOOKUPS = "lookups";
        //#endregion

        //#region Users
        public static readonly USER_MANAGEMENT = "user-management";
        //#endregion

        // #region financials
        public static readonly FINANCIALS = "financials";

        //#region Services
        public static readonly SERVICES = "services";
        public static readonly ALL = "all";
        public static readonly EMPTY = "empty";
        public static readonly REQUESTS = "requests"
        public static readonly REQUESTDETAILS = "requestdetails"
        //#endregion



        public static readonly PRIVACY_POLICY = "policy";
        public static readonly USIBILITY_CONDITIONS = "usibility-conditions";
        public static readonly SITE_MAP="site-map";
        public static readonly CONTACT_US="contact-us";
    }
    //#endregion

    //#region Controllers
    static CONTROLLERS = class {



        public static readonly ACCOUNT = 'Account';
        public static readonly USER = 'User';
        public static readonly REGISTER = 'Register';
        public static readonly VENDOR = 'vendor';
        public static readonly TENDERS = 'tenders';
        public static readonly BankAPI = 'BankAPI';
        public static readonly Lookups = 'Lookups';
        public static readonly notifications = 'notificaitons';
        public static readonly Messages = 'Messages';
        public static readonly Documents = 'Documents';
        public static readonly Common = 'Common';
        public static readonly FAQs = 'FAQs';



        public static readonly bids = 'Bids';
        public static readonly PurchaseOrder= 'PurchaseOrder';
        public static readonly PurchaseRequests = 'PurchaseRequests';
        public static readonly EVALUATIONS = 'Evaluations';
        public static readonly PurchaseRequisition = 'PurchaseRequisition';

    }
    //#endregion

    //#region Actions
    static ACTIONS = class {
        //#region Account Controller


        public static readonly SendEmailTest = 'SendEmailTest';
        public static readonly GetAllVendors = 'GetAllVendors';
        public static readonly GetAllVendorsInfo = 'GetAllVendorsInfo';
        public static readonly ConfirmPO = 'ConfirmPO';
        public static readonly DeleteVendor = 'DeleteVendor';
        public static readonly MigrateVendorToERP = 'MigrateVendorToERP';
        public static readonly InviteVendor = 'InviteVendor';
        public static readonly Admin_GetVendorDetailsByID = 'Admin-GetVendorDetailsByID';
        public static readonly Admin_ApproveVendor = 'Admin-ApproveVendor';
        public static readonly Admin_RejectVendor = 'Admin-RejectVendor';
        public static readonly Admin_SendVendorWorkflowReminder = 'Admin-SendVendorWorkflowReminder';
        public static readonly Admin_RequestVendorChange = 'Admin-RequestVendorChange';
        public static readonly Admin_GetVendorWorkflowChildTasks = 'Admin-GetVendorWorkflowChildTasks';
        public static readonly Admin_CreateVendorWorkflowChildTask = 'Admin-CreateVendorWorkflowChildTask';
        public static readonly Admin_CompleteVendorWorkflowChildTask = 'Admin-CompleteVendorWorkflowChildTask';
        public static readonly Public_GetVendorWorkflowChildTaskDetails = 'Public-GetVendorWorkflowChildTaskDetails';
        public static readonly Public_CompleteVendorWorkflowChildTask = 'Public-CompleteVendorWorkflowChildTask';
        public static readonly Admin_GetBankAccountsByVendorID = 'Admin-GetBankAccountsByVendorID';
        public static readonly Admin_ApproveBankAccount = 'Admin-ApproveBankAccount';
        public static readonly Admin_RejectBankAccount = 'Admin-RejectBankAccount';

        public static readonly GetTemplates = 'GetTemplates';
        public static readonly GetKeysByTemplate = 'GetKeysByTemplate';
        public static readonly UpdateEmailTemplate = 'UpdateEmailTemplate';
        public static readonly GetDocuments = 'GetDocuments';


        public static readonly AUTHENTICATE = 'Authenticate';
        public static readonly VerifyOTP = 'verify-otp';
        public static readonly Generateotp = 'generateotp';
        public static readonly Admin_GetUsers = 'Admin-GetUsers';
        public static readonly Admin_CreateUser = 'Admin-CreateUser';
        public static readonly Admin_UpdateUser = 'Admin-UpdateUser';
        public static readonly Admin_SetUserActive = 'Admin-SetUserActive';
        public static readonly Admin_ResetUserPassword = 'Admin-ResetUserPassword';
        public static readonly SubmitTender = 'SubmitTender'
        public static readonly ApproveTender = 'ApproveTender'
        public static readonly PublishTender = 'PublishTender'
        public static readonly CloseTenderForBidding = 'CloseTenderForBidding'
        public static readonly ReopenTenderForBidding = 'ReopenTenderForBidding'
        public static readonly RequestTenderChange = 'RequestTenderChange'
        public static readonly GetDashboardData = 'GetDashboardData'


        public static readonly CHANGEPASSOWRD = 'changePassword';
        public static readonly ForceChangePassword = 'force-change-password';
        public static readonly VerifyEmail = 'verifyemail';
        public static readonly VerifyEmailPassword = 'verify-email-Password';
        public static readonly REGISTERVENDOR = 'RegisterVendor';


        public static readonly GetPurchaseOrders = 'GetPurchaseOrders';
        public static readonly GetPayments = 'GetPayments';
        public static readonly GetGRNSPurchaseOrders = 'GetGRNSPurchaseOrders';
        public static readonly GetInvoicesPurchaseOrders = 'GetInvoicesPurchaseOrders';


        public static readonly GetBidDetails = 'GetBidDetails';
        public static readonly GetBidDetailsByBidId = 'GetBidDetailsByBidId';
        public static readonly VerifyJoiningFeePayment = 'VerifyJoiningFeePayment';
        public static readonly GetEvaluationDetailsById = 'GetEvaluationDetailsById';

        public static readonly CheckEmailInUse = 'CheckEmailInUse';
        public static readonly ValidateVendorData = 'ValidateVendorData';

        public static readonly GetVendorByReferenceNo = 'GetVendorByReferenceNo';

        public static readonly UPDATEVENDOR = 'UPDATEVENDOR';

        public static readonly UploadDocumnets = 'UploadDocumnets';
        public static readonly UpdateDocuments = 'UpdateDocuments';

        public static readonly RemoveDocument = 'RemoveDocument';

        public static readonly GetBids = 'GetBids';
        public static readonly GetAllBids = 'GetAllBids';
        public static readonly GetBidsByTenderNumber = 'GetBidsByTenderNumber';
        public static readonly GetEvaluationBidsByTenderNumber = 'GetEvaluationBidsByTenderNumber';

        public static readonly SubmitBid = 'SubmitBid';

        public static readonly UpdateOrCreateInvoice = 'UpdateOrCreateInvoice';

        public static readonly RequestGRN = 'RequestGRN';

        public static readonly GetGRNs = 'GetGRNSPurchaseOrders';

        public static readonly GetInvoices = 'GetInvoicesPurchaseOrders';







        public static readonly PREVIEW = '/api/documents/preview';















        public static readonly ACQUIRE_TOKEN = 'AcquireToken';
        public static readonly REFRESH_TOKEN = 'RefreshToken';
        public static readonly FAMILY = "family";
        public static readonly GetAccount = "GetAccount";
        public static readonly MEMBERS = "members";
        public static readonly NOMINEE = "Nominee";
        public static readonly REQUESTS = "requests";
        public static readonly REQUESTSDETAILSIN = "GetRequestById";
        public static readonly GetCountries = 'countries';
        public static readonly GetCurrencies = 'currencies';

        //#endregion

        //#region Request
        public static readonly SubmitLicencehouseBenfitRequestWithLoanForMarried = "SubmitLicencehouseBenfitRequestWithLoanForMarried";

        //#endregion

        //#region Banner
        public static readonly ALL = "All";
        public static readonly Get = "Get";

        //#region Vendor
        public static readonly GetProfile = 'GetProfile';
        public static readonly GetVendorDetails = 'GetVendorDetails';
        public static readonly UpdateVendorByID = "UpdateVendorByID";
        public static readonly UpdateVendor = "UpdateVendor";
        public static readonly UpdateVendorPassword = "UpdateVendorPassword";
        public static readonly CreateVendor = "CreateVendor";
        public static readonly AddContactPerson = "AddContactPerson";
        public static readonly UpdateContactPerson = "UpdateContactPerson";
        public static readonly InviteContactPerson = "InviteContactPerson";
        public static readonly RemoveContactPerson = "RemoveContactPerson";
        public static readonly SetContactAsPrimary = "SetContactAsPrimary";
        public static readonly SetContactAsSecondary = "SetContactAsSecondary";
        public static readonly UpdateContactEmail = "UpdateContactEmail";
        public static readonly UpdateContactPassword = "UpdateContactPassword";
        //#endregion

        //#region notificaitons
        public static readonly getNotifications = "GetNotifications";
        public static readonly deleteallnotifacitons = "ClearAllNotifications";
        public static readonly deleteanotifaciton = "ClearNotification";
        //#endregion

        //#region Tender
        public static readonly GetTenders = 'GetTenders';
        public static readonly GetAllTenders = 'GetAllTenders';
        public static readonly GetTenderListData = 'GetTenderListData';
        public static readonly GetTender = 'GetTender';
        public static readonly GetTenderByTenderID = 'GetTenderByTenderID';
        public static readonly GetTenderDocuments = 'GetTenderDocuments';
        public static readonly AdminCreateOrUpdateTender = 'Admin-CreateOrUpdateTender';
        public static readonly AdminCreateOrUpdateTenderNew = 'Admin-CreateOrUpdateTenderNew';
        public static readonly AdminRemoveTender = 'Admin-RemoveTender';
        //#endregion

        //#region Common
        public static readonly AdminPublishRequest = 'Admin-PublishRequest';
        //#endregion

        //#region Evaluations
        public static readonly GetAllEvaluations = 'GetAllEvaluations';
        public static readonly GetAllEvaluators = 'GetAllEvaluators';
        public static readonly AssignEvaluators = 'AssignEvaluators';
        public static readonly SaveAssignmentDraft = 'SaveAssignmentDraft';
        public static readonly GetAssignmentDraft = 'GetAssignmentDraft';
        public static readonly GetDraftEvaluationDetails = 'GetDraftEvaluationDetails';
        public static readonly ClearAssignmentDraft = 'ClearAssignmentDraft';
        public static readonly SubmitDecisions = 'SubmitDecisions';
        public static readonly ReviewEvaluation = 'ReviewEvaluation';
        public static readonly GetEvaluationScoringData = 'GetEvaluationScoringData';
        //#endregion

        //#region Purchase Requisition
        public static readonly GetAllApprovedPR = 'GetAllApprovedPR';
        public static readonly GetAllApprovedPRsForTenderScope = 'GetAllApprovedPRsForTenderScope';
        public static readonly GetApprovedRecordByPRNumber = 'GetApprovedRecordByPRNumber';
        public static readonly UpdateTCFlag = 'UpdateTCFlag';
        //#endregion

        //#region Departments
        public static readonly GetAllDepartments = 'GetAllDepartments';
        public static readonly GetDepartmentById = 'GetDepartmentById';
        //#endregion

        //#region FAQs
        public static readonly GetAllFAQs = 'GetAllFAQs';
        public static readonly GetFAQById = 'GetFAQById';
        public static readonly CreateFAQ = 'CreateFAQ';
        public static readonly UpdateFAQ = 'UpdateFAQ';
        public static readonly DeleteFAQ = 'DeleteFAQ';
        public static readonly PublishFAQ = 'PublishFAQ';
        //#endregion

        //#region BankApi
        public static readonly GetBankAccounts = 'GetBankAccounts';
        public static readonly SubmitBankAccount = 'SubmitBankAccount';
        public static readonly UpdateBankDetailsByVendorID = 'UpdateBankDetailsByVendorID';
        //#endregion

        //#region Lookup

        //#endregion

        //#region AWARD
        public static readonly ROUTE = "Route";
        //#endregion

        //#region Training
        public static readonly PARTICIPATION = "Participation";
        public static readonly CANDIDATE = "Candidate";
        //#endregion

        //#region MARKETING_EXHIBITIONS
        //#endregion

        //#region Attachment
        public static readonly UPLOAD = "Upload";
        public static readonly TEMP = "Temp";
        public static readonly DELETE = "Delete";
        public static readonly DOWNLOAD = "Download";
        //#endregion
        //#region Integration
        public static readonly MOI = "MOI";
        public static readonly SAP = "SAP";
        public static readonly GET_NATIONAL_ADDRESS_BY_QID = "GetNationalAddressByQId";
        public static readonly GET_PERSONNEL_INFO_BY_QID_DETAILS = "GePersonnelInfobyQIdDetails"
        public static readonly GRSIA = "GRSIA";
        public static readonly GET_BENEFICIARY_DETAILS_BY_QID = "GetBeneficiaryDetailsByQId";
        public static readonly MOCI = "MOCI";
        public static readonly GET_BY_CR_NUMBER = "GetByCRNumber";
        public static readonly GET_EMP_DATA = "GetEmpData";
        public static readonly MSDF = "qnbn";
        public static readonly GET_SOCIAL_SECURITY = "GetSocialSecurity"

        public static readonly sendMessage = 'sendMessage';
        public static readonly GetMessages = 'GetMessages';


        //#endregion
    }
    //#endregion

    //#region CLAIMS
    static CLAIMS = class {
        //#region Account Controller
        public static readonly UserId = 'UserId';
        public static readonly FullName = 'FullName';
        public static readonly MiddleName = 'MiddleName';
        public static readonly LastName = 'LastName';
        public static readonly MobilePhone = 'Phone';
        public static readonly EmailAddress = 'EmailAddress';
        public static readonly NameIdentifier = 'NameIdentifier';
        public static readonly BirthDate = 'BirthDate';
        public static readonly Gender = 'Gender';
        public static readonly Status = 'Status';
        public static readonly Active = 'Active';
        public static readonly Role = 'Role';
        //#endregion
    }
    //#endregion

    //#region Banner Items
    static BANNER_ITEMS = class {
        public static readonly AWARD_PRODUCT = 'AwardProduct';
        public static readonly TRAININGS = 'Training';
        public static readonly AWARDS = 'Award';
        public static readonly MARKETING_EXHIBITIONS = 'MarketingExhibition';
    }
    //#endregion

    //#region Available Service Type
    static TYPES = class {
        public static readonly AWARD = "Award";
        public static readonly PRODUCT_AWARD = "AwardProduct";
        public static readonly MARKETING_EXHEBITION = "MarketingExhibition";
        public static readonly TRAINING = "Training";
    }
    //#endregion

    //#region File Types
    static FILE_TYPES = class {
        public static readonly ID = "Id";
        public static readonly CR = "CR";
        public static readonly CERTIFICATE = "Certificate";
    }
    //#endregion
}
